import { getCurrencyPending, getCurrencySuccess, getCurrencyFail, 
    deleteCurrencyPending, deleteCurrencySuccess, deleteCurrencyFail,
    getSCurrencyPending, getSCurrencySuccess, getSCurrencyFail, 
    createCurrencyPending, createCurrencySuccess, createCurrencyFail, 
    modifyCurrencyPending, modifyCurrencySuccess, modifyCurrencyFail } from "./currencySlice";
import { fetchAllCurrency, currencyDelete, currencyCreation, currencyModify, fetchSingleCurrency } from "../../../api/userApi";
import Swal from "sweetalert2";

export const getAllCurrency = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getCurrencyPending());
        const result = await fetchAllCurrency();
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

        console.log('allCurrencyData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const currencydetails = JSON.parse(JSON.stringify(myObj.currencies));
        const currencydetails1 = JSON.parse(JSON.stringify(currencydetails));
        
        if (currencydetails) {
        
            return dispatch(getCurrencySuccess(currencydetails));
        }
        dispatch(getCurrencyFail("Currency is not found"));


    } catch (error) {
       
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getCurrencyFail(err.msg));

    }
}

export const currencyDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteCurrencyPending());
        const result = await currencyDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteCurrencySuccess("Country deleted"))
        : dispatch(deleteCurrencyFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteCurrencyFail(err.msg));
    }
    
}

export const newCurrencyCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createCurrencyPending());
        const result = await currencyCreation(frmDt);
        console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createCurrencySuccess(result.message))
            : dispatch(createCurrencyFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
         console.log("catch block");
         console.log(error);
        const err = JSON.parse(JSON.stringify(error.response.data.error));
         Swal.fire(err.msg, '', 'error')
       
        
          dispatch(createCurrencyFail());
               
    }

}

export const getSingleCurrency = (id) => async (dispatch) => {
    
 
    try {
     //call the api
    dispatch(getSCurrencyPending());
    const result = await fetchSingleCurrency(id);
   // const userData=JSON.parse(result.user);
 console.log('CurrencyData ');
 //console.log(result);
 console.log(result.countries);
 
 //console.log('check user profile out if');
    if(result.currencies[0] && result.currencies[0].id){
    //console.log('check user profile');
        return dispatch(getSCurrencySuccess(result.currencies[0]));
    }
    dispatch(getSCurrencyFail("Currency is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
   // console.log(err.msg);
    dispatch(getSCurrencyFail(err.msg));
 
 }
    
 
 }




export const currencyModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyCurrencyPending());
        const result = await currencyModify(frmDt);
        result.status === "success"
            ? dispatch(modifyCurrencySuccess(result.message))
            : dispatch(modifyCurrencyFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        console.log(error)
     
        dispatch(modifyCurrencyFail(err.msg));
        Swal.fire(err.msg, '', 'error')
        
    }

}
